export default __webpack_public_path__ + "static/media/bellnotification.a3dd13b6.wav";